import styled from "styled-components";

const GameResume = styled.div`
  text-align: justify;
  margin-bottom: 2%;
  font-size: 1.3em;
`;

export default GameResume;
